(function ($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfJoinFormConfirmTable', [function () {
        var link = function (scope) {
            scope.updateConfirmTable = function() {
                scope.confirmTable.cover.rows = [];
                scope.confirmTable.eligibility.rows = [];
                scope.confirmTable.personal.rows = [];
                scope.confirmTable.contact.rows = [];
                scope.confirmTable.payment.rows = [];

                //-----------------------------------------------------------------
                //
                // Cover
                //
                //-----------------------------------------------------------------
                confirmTableRow('cover', 'Member Type', optionsLabel(scope.field.cover.memberType, scope.model.cover.memberType));
                confirmTableRow('cover', 'State', optionsLabel(scope.field.cover.state, scope.model.cover.primaryState));
                confirmTableRow('cover', 'Cover', coverValue()); // Top Hospital, Top Extras | Emergency Ambulance | StarterPak
                confirmTableRow('cover', 'Cover Start Date', moment(scope.model.cover.coverStartDate).format('DD/MM/YYYY'));
                // Only display the following if the rebate tier selected
                if( scope.model.cover.medicareEligibility == 'Y' && scope.model.cover.governmentRebate == 'Y' ) {
                    confirmTableRow('cover', 'Rebate Income Tier', optionsLabel(scope.field.cover.governmentRebateIncomeTier, scope.model.cover.governmentRebateIncomeTier));
                }
                // Only display the following if the lifetime loading has been activated.

                if( scope.quoteData.lifetimeHealthCoverPercentage > 0 ) {
                    confirmTableRow('cover', false, 'A Lifetime Cover Loading of '+scope.quoteData.lifetimeHealthCoverPercentage+'% has been added to your cover');
                }


                //-----------------------------------------------------------------
                //
                // Eligibility
                //
                //-----------------------------------------------------------------
                // This is mandatory so they will never get to this point without selecting this.
                confirmTableRow('eligibility', false, 'Yes I am eligible');

                //-----------------------------------------------------------------
                //
                // Personal Details
                //
                //-----------------------------------------------------------------
                confirmTableRow('personal', 'Name', scope.model.personal.memberFirstName+' '+scope.model.personal.memberLastName);
                confirmTableRow('personal', 'DOB', moment(scope.model.personal.memberDOB).format('DD/MM/YYYY'));
                if( scope.model.cover.memberType == 'Cpl' || scope.model.cover.memberType == 'Fam' ) {
                    confirmTableRow('personal', 'Partner Name', scope.model.personal.partner.partnerFirstName+' '+scope.model.personal.partner.partnerLastName);
                    confirmTableRow('personal', 'Partner DOB', moment(scope.model.personal.partner.partnerDOB).format('DD/MM/YYYY'));
                }

                if( scope.model.cover.medicareEligibility == 'Y' && scope.model.cover.governmentRebate == 'Y' ) {
                    confirmTableRow('personal', 'Medicare Number', scope.model.personal.medicareNumber);
                    confirmTableRow('personal', 'Name on Medicare Card', scope.model.personal.medicareFirstName+' '+scope.model.personal.medicareInitial+' '+scope.model.personal.medicareLastName);
                    confirmTableRow('personal', 'Medicare Expiry', scope.model.personal.medicareExpiry);                }


                //-----------------------------------------------------------------
                //
                // Contact Details
                //
                //-----------------------------------------------------------------
                confirmTableRow('contact', 'Email', scope.model.contact.emailAddress);
                if( scope.model.contact.phoneNumber.length && scope.model.contact.phoneNumber.length > 0 ) {
                    for( var i in scope.model.contact.phoneNumber ) {
                        if( scope.model.contact.phoneNumber.hasOwnProperty(i) ) {

                            confirmTableRow('contact', scope.model.contact.phoneNumber[i].type.capitalize(), scope.model.contact.phoneNumber[i].value);
                        }
                    }
                }

                confirmTableRow('contact', 'Home Address', scope.model.contact.homeAddress.AddressLine+','
                    +scope.model.contact.homeAddress.Locality+','
                    +scope.model.contact.homeAddress.State+','
                    +scope.model.contact.homeAddress.Postcode
                );
                if( scope.model.contact.postalAddressSameAsHome == 'Y' ) {
                    confirmTableRow('contact', 'Postal Address', 'Same as above.');
                }
                else {
                    confirmTableRow('contact', 'Postal Address', scope.model.contact.postalAddress.AddressLine+','
                        +scope.model.contact.postalAddress.Locality+','
                        +scope.model.contact.postalAddress.State+','
                        +scope.model.contact.postalAddress.Postcode);
                }


                //-----------------------------------------------------------------
                //
                // Payment Details
                //
                //-----------------------------------------------------------------
                confirmTableGroup('payment', 'Direct Debit');
                confirmTableRow('payment', 'Name', scope.model.payment.paymentAccountName);
                confirmTableRow('payment', 'BSB Number', scope.model.payment.paymentAccountBSB);
                confirmTableRow('payment', 'Account Number', scope.model.payment.paymentAccountNumber);
                confirmTableRow('payment', 'Payment Frequency', scope.model.payment.paymentFrequency);
                confirmTableRow('payment', 'Initial Deduction Date',  moment(scope.model.payment.paymentInitialDeductionDate).format('DD/MM/YYYY'));
                // They cannot progress without first ticking this box.
                confirmTableRow('payment', false, 'I agree to the terms of the Direct Debit Agreement');

                confirmTableGroup('payment', 'Benefits');
                // Only show this when they have selected the check box.
                if( scope.model.payment.benefitsSameAsAbove == 'Y' ) {
                    confirmTableRow('payment', false, 'Pay my benefits into the same account as above');
                }
                else {
                    confirmTableRow('payment', 'Name', scope.model.payment.benefitsAccountName);
                    confirmTableRow('payment', 'BSB Number', scope.model.payment.benefitsAccountBSB);
                    confirmTableRow('payment', 'Account Number', scope.model.payment.benefitsAccountNumber);
                }


            }

            function confirmTableGroup(tabName, label) {
                scope.confirmTable[tabName].rows.push({
                    'group': label
                });
            }

            function confirmTableRow(tabName, label, value) {
                scope.confirmTable[tabName].rows.push({
                    'label': label,
                    'value': value
                });
            }

            function optionsLabel(field, value) {
                var item = _.find(field.options, {value: value});
                if (typeof item !== 'undefined' && item.label) {
                    return item.label;
                }
                return '';
            }

            function optionsTierName(field, value) {
                var item = _.find(field.options, {value: value});
                if (typeof item !== 'undefined' && item.tierName) {
                    return item.tierName;
                }
                return '';
            }


            function coverValue() {
                if (scope.model.cover.emergencyAmbulance == 'Y') {
                    return optionsLabel(scope.field.cover.emergencyAmbulance, 'Amb');
                }
                else if (scope.model.cover.hospitalCover == 'SP' ) {
                    var label = optionsLabel(scope.field.cover.hospitalCover, scope.model.cover.hospitalCover);
                    var tierName = optionsTierName(scope.field.cover.hospitalCover, scope.model.cover.hospitalCover);
                    var tierHtml = '';
                    if(tierName !== '') {
                        tierHtml = ' <span class="tier-pill">'+tierName+'</span>';
                    }
                    return label + tierHtml;
                }
                else {
                    var value = '';
                    if( scope.model.cover.hospitalCover != '' ) {
                        var label = optionsLabel(scope.field.cover.hospitalCover, scope.model.cover.hospitalCover);
                        var tierName = optionsTierName(scope.field.cover.hospitalCover, scope.model.cover.hospitalCover);
                        var tierHtml = '';
                        if(tierName !== '') {
                            tierHtml = ' <span class="tier-pill">'+tierName+'</span>';
                        }
                        value += label + tierHtml;
                    }
                    if( scope.model.cover.extrasCover != '' ) {
                        if( value != '' ) { value += ' & '; }
                        value += optionsLabel(scope.field.cover.extrasCover, scope.model.cover.extrasCover );
                    }
                    return value;
                }
            }


            /*scope.$watch('model', function (newValue, oldValue) {
                updateConfirmTable();
            }, true);*/

        };
        return {
            'restrict': 'E',
            'link': link,
            'replace': true,
            'templateUrl': function (elem, attr) {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/partials/confirm-table.html');
            }
        };
    }]);
})(jQuery, angular, window);
